(function () {
  var BANNER_CLASS = "js-nextDayBanner";
  var STYLE_ID = "next-day-banner-styles";
  var RUN_FOR_MS = 8000;
  var TICK_MS = 300;

  function getBadgeText() {
    var el = document.querySelector("#DeliveryBannerFlag");
    if (!el) return "";
    var text = (el.getAttribute("data-pdpbadge-text") || "").trim();
    return text;
  }

  function isEnabled(text) {
    return !!text;
  }

  function injectStylesOnce() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.type = "text/css";
    style.appendChild(
      document.createTextNode(
        "." + BANNER_CLASS + "{" +
          "position:absolute;" +
          "bottom:45px;" +
          "left:50%;" +
          "transform:translateX(-50%);" +
          "background-color:#f7f7f7;" +
          "padding:6px 14px;" +
          "border-radius:30px;" +
          "text-align:center;" +
          "z-index:9999;" +
          "pointer-events:none;" +
          "box-shadow:0 1px 3px rgba(0,0,0,0.1);" +
          "font-family:var(--chassi-m-regular, Arial, sans-serif);" +
          "font-weight:400;" +
          "font-style:normal;" +
          "font-size:1.25rem;" +
          "line-height:1.9rem;" +
          "letter-spacing:0;" +
          "color:#000;" +
        "}" +
        "@media (min-width:1024px){" +
          "." + BANNER_CLASS + "{" +
            "font-size:1.8rem;" +
            "line-height:2.2rem;" +
            "padding:8px 18px;" +
          "}" +
        "}"
      )
    );
    document.head.appendChild(style);
  }

  function removeBanners() {
    var banners = document.querySelectorAll("." + BANNER_CLASS);
    for (var i = 0; i < banners.length; i++) banners[i].remove();
  }

  function findSlides(root) {
    var selectors = [
      ".ProductImages__slide",
      ".product__media-item",
      "[data-product-media-wrapper]",
      ".swiper-slide"
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = root.querySelectorAll(selectors[i]);
      if (nodes && nodes.length) return nodes;
    }

    // fallback
    for (var j = 0; j < selectors.length; j++) {
      var nodes2 = document.querySelectorAll(selectors[j]);
      if (nodes2 && nodes2.length) return nodes2;
    }

    return [];
  }

  function getProductRoot() {
    var form = document.querySelector('form[action^="/cart/add"]');
    if (form) {
      var el = form;
      for (var i = 0; i < 8 && el; i++) el = el.parentElement;
      return el || document;
    }
    return document;
  }

  function ensurePositionContext(el) {
    try {
      if (window.getComputedStyle(el).position === "static") {
        el.style.position = "relative";
      }
    } catch (e) {}
  }

  function injectIntoSlide(slide, text) {
    if (!slide || slide.nodeType !== 1) return;

    // If banner already exists, update its text (so changing tags updates instantly)
    var existing = slide.querySelector("." + BANNER_CLASS);
    if (existing) {
      if (existing.textContent !== text) existing.textContent = text;
      return;
    }

    var anchor =
      slide.querySelector("picture") ||
      slide.querySelector("img") ||
      slide.querySelector("video") ||
      slide;

    var container = anchor && anchor.parentElement ? anchor.parentElement : slide;
    ensurePositionContext(container);

    var banner = document.createElement("div");
    banner.className = BANNER_CLASS;
    banner.textContent = text;

    container.appendChild(banner);
  }

  function runOnce() {
    // Only on product pages
    if (!document.querySelector('form[action^="/cart/add"]')) return;

    var text = getBadgeText();

    // No tag => OFF
    if (!isEnabled(text)) {
      removeBanners();
      return;
    }

    injectStylesOnce();

    var root = getProductRoot();
    var slides = findSlides(root);
    if (!slides || !slides.length) return;

    for (var i = 0; i < slides.length; i++) {
      injectIntoSlide(slides[i], text);
    }
  }

  function init() {
    runOnce();

    var start = Date.now();
    var interval = setInterval(function () {
      runOnce();
      if (Date.now() - start > RUN_FOR_MS) clearInterval(interval);
    }, TICK_MS);

    var mo = new MutationObserver(function () {
      runOnce();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener("shopify:section:load", runOnce);
    document.addEventListener("shopify:section:reorder", runOnce);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();